<div fxLayout="row" fxLayoutAlign="space-between center" class="header-create-section">
    <button (click)="goBack()" mat-button style="width: fit-content;" color="primary">
        <mat-icon color="primary">arrow_back</mat-icon>
        Regresar
    </button>
    <h2 class="title-page">Registrar diligencia</h2>
    <div></div>
</div>
<form [formGroup]="form">
    <div fxLayout="column" fxLayoutAlign="start">
        <div fxLayout="row" fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="space-start stretch"
             fxLayoutAlign.sm="space-start stretch" fxLayoutAlign.xs="space-around stretch">
            <mat-form-field appearance="outline" fxFlex="100%" class="px-4">
                <mat-label>Expediente</mat-label>
                <input matInput formControlName="expediente" [matAutocomplete]="autoExpediente">
                <mat-icon matSuffix>arrow_drop_down</mat-icon>
                <mat-autocomplete #autoExpediente="matAutocomplete" [displayWith]="displayFn"
                                  (optionSelected)="onChangeSelectExpediente($event.option.value)">
                    <mat-option *ngFor="let option of expedienteFilteredOptions$ | async" [value]="option">
                        <span>{{option.label}}</span>
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </div>

        <div fxLayout="row" fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="space-start stretch"
             fxLayoutAlign.sm="space-start stretch" fxLayoutAlign.xs="space-around stretch">
            <mat-form-field appearance="outline" fxFlex="100%" class="px-4">
                <mat-label>Diligencia</mat-label>
                <input matInput formControlName="diligencia" [matAutocomplete]="autoDiligencia">
                <mat-icon matSuffix>arrow_drop_down</mat-icon>
                <mat-autocomplete #autoDiligencia="matAutocomplete" [displayWith]="displayFn"
                                  (optionSelected)="onSelectDiligencia($event.option.value)">
                    <mat-option *ngFor="let option of diligenciaFilteredOptions$ | async" [value]="option">
                        <span>{{option.label}}</span>
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </div>
    </div>
</form>

<div fxLayout="row" fxLayoutAlign="end end">
    <button (click)="continuar()" [disabled]="!form.valid" mat-raised-button type="button" color="accent">
        Siguiente
    </button>
</div>
